document.addEventListener("DOMContentLoaded", function () {
    var swiperEl = document.querySelector('.mySwiper');
    if (swiperEl) {
        var swiper = new window.Swiper(".mySwiper", {
            slidesPerView: 1,
            spaceBetween: 30,
            centeredSlides: true,
            loop: false,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                }
            },
            on: {
                slideChangeTransitionEnd: function() {
                    updateActiveSlide(this);
                },
                init: function() {
                    updateActiveSlide(this);
                },
            },
        });

        function updateActiveSlide(swiperInstance) {
            swiperInstance.slides.forEach(slide => slide.classList.remove("is-active"));
            const realCenterIndex = swiperInstance.realIndex;

            swiperInstance.slides.forEach((slide) => {
                if (slide.getAttribute("data-swiper-slide-index") == realCenterIndex) {
                    slide.classList.add("is-active");
                }
            });
        }
        console.log('Swiper initialized with active slide tracking');
    } else {
        console.log('Swiper element .mySwiper not found');
    }
});
